import { demoModeAtom } from '@/global-store';
import { Tag } from '@eye-able/ui';
import { useAtom } from 'jotai';
import { Link } from 'react-router-dom';
import { useOrgBranding } from '@/branding/useOrgBranding';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

function LogoSection({ dark }: { dark?: boolean }) {
  const { t } = useInlineTranslation();
  const [demoMode] = useAtom(demoModeAtom);
  const branding = useOrgBranding();

  // A branded header has a coloured background, so use the white logo/wordmark
  // for contrast regardless of the `dark` prop.
  const onColouredHeader = Boolean(branding);
  const useBlack = dark && !onColouredHeader;
  const logoSrc =
    branding?.customLogoUrl ??
    (useBlack
      ? 'https://assets.eye-able.com/dashboard-assets/logos/eye-able-logo_schwarz.svg'
      : 'https://assets.eye-able.com/dashboard-assets/logos/eye-able-logo_weiss.svg');

  return (
    <div className='eye:flex eye:items-center eye:whitespace-nowrap'>
      {/* The logo can be a partner's, and the link goes to the dashboard start
          page rather than eye-able.com, so name the destination, not the image. */}
      <Link to='/' aria-label={t('dashboardHomeLink')}>
        <img alt='' id='customlogo' src={logoSrc} className='eye:h-[52px]' />
      </Link>
      {demoMode && <Tag>Demo</Tag>}
    </div>
  );
}

export default LogoSection;
